function getVerifiedText(mobilityOffer) {
  if (!mobilityOffer) {
    return '';
  }

  switch (mobilityOffer.verified) {
    case true:
      return 'Geverifieerd';
    case false:
      return 'Niet geverifieerd';
    default:
      return 'Data van de Federale Diagnostiek Mobiliteit';
  }
}

export {
  getVerifiedText,
};